import { render } from "./IconOrSvg.vue?vue&type=template&id=49c746be&scoped=true"
import script from "./IconOrSvg.vue?vue&type=script&lang=js"
export * from "./IconOrSvg.vue?vue&type=script&lang=js"

import "./IconOrSvg.vue?vue&type=style&index=0&id=49c746be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c746be"]])

export default __exports__